// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8i1CY","select":"styles_select__3z5yx"};